import { FormControl, FormGroup, Validators } from '@angular/forms';
import { createCustomerDataForm } from '@shared/factories/customer-form.factory';
import { BvsCharterKautionsversicherungFormModel } from '../models/forms/bvs-charter-kautionsversicherung-form.model';
import { BoatType, Country } from '@backend/models';

export function createBvsCharterKautionsversicherungForm(): FormGroup<BvsCharterKautionsversicherungFormModel> {
  return new FormGroup<BvsCharterKautionsversicherungFormModel>({
    boatType: new FormControl<BoatType | null>(null, [Validators.required]),
    kautionsBetragInEur: new FormControl<number | null>(null, [Validators.max(6000), Validators.required]),
    isCharterFolgeschadenVersicherungSelected: new FormControl<boolean | null>(null, [Validators.required]),
    yachtLengthInFeet: new FormControl<number | null>(null),
    customerData: createCustomerDataForm(),
    personLandHauptwohnsitz: new FormControl<Country | null>(null, [Validators.required])
  });
}
